import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Alert } from 'reactstrap';
import { gql } from 'apollo-boost';
import { Query, Mutation, withApollo } from 'react-apollo';
import { Formik } from 'formik';
import Spinner from '~/components/spinner/spinner';
import OrderForm from '~/components/orderForm/orderForm';
import { orderValidationSchema } from '../../validation/order';

export const getCustomerQuery = gql`
  query customer($id: Int!) {
    customer(id: $id) {
      id
      name
    }
  }
`;

export const createOrderMutation = gql`
  mutation updateCustomer($id: Int!) {
    updateCustomer(id: $id) {
      id
    }
  }
`;

export class CustomerOrder extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.id === nextProps.id) {
      // Same issue around bad things happening with the Query onCompleted callback
      return false;
    }

    return true;
  }

  render() {
    const { onCompleted, id, history } = this.props;
    return (
      <Query query={getCustomerQuery} variables={{ id }} onCompleted={onCompleted} fetchPolicy={'cache-and-network'}>
        {props => {
          const { loading, error, data } = props;
          if (loading) {
            return <Spinner className="absolute absolute-center stroke-brand-red" />;
          }

          if (error) {
            return <Alert color="danger">Sorry, there was an error getting the customer</Alert>;
          }

          const { customer } = data;
          return (
            <div className="content">
              <Mutation mutation={createOrderMutation}>
                {(createOrder, { error }) => (
                  <Formik
                    initialValues={{
                      customerId: customer.id,
                      orderLines: [
                        {
                          quantity: 1
                        }
                      ]
                    }}
                    validateOnChange={false}
                    validateOnBlur={false}
                    validationSchema={orderValidationSchema}
                    onSubmit={async (values, { setErrors, setSubmitting }) => {
                      try {
                        await createOrder({
                          variables: values
                        });
                        history.push(`/customers/${id}?updated=true`);
                      } catch (err) {
                        console.log(err);
                        setErrors({
                          unknown: 'An unknown error occured'
                        });
                        setSubmitting(false);
                      }
                    }}
                    render={OrderForm}
                  />
                )}
              </Mutation>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default withRouter(withApollo(CustomerOrder));



// WEBPACK FOOTER //
// ./src/containers/customerOrder/customerOrder.jsx